import $ from 'jquery';
import React from 'react';

import '../../mui/tumbler';

export default class Tumbler extends React.Component {
    static defaultProps = {
        checked: false,
        labelHidden: false,
        text_on: 'Вкл',
        text_off: 'Выкл',
    };

    componentDidMount() {
        $(this.tumbler).tumbler({
            checked: !!this.props.checked,
            text: {
                on: this.props.text_on,
                off: this.props.text_off,
            },
            labelHidden: this.props.labelHidden,

            change: (event, data) => {
                if (data.from_ui) this.props.onChange?.(data.checked);
            },
        });
    }

    componentWillUnmount() {
        $(this.tumbler).tumbler('destroy');
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $(this.tumbler).tumbler('checked', !!this.props.checked);
    }

    set_tumbler = (tumbler) => (this.tumbler = tumbler);

    render() {
        return <div ref={this.set_tumbler} />;
    }
}
